import { styles } from '../../../../../../styles/tailwind-config'
import { Label } from '../../../../../../components/ui/label'
import { Combobox } from '../../../../../../components/ui/combobox'
import { useInterventionInput } from '../../../../../../context/InterventionInputContext'
import { AutosizeTextarea } from '../../../../../../components/ui/textarea-autosize'
import { useBoundStore } from '../../../../../../zustand'
import { Trans, useLingui } from '@lingui/react/macro'
import { getCustomSettings } from '../../../../../../config/custom-settings'
import { useAuth } from '../../../../../../context/AuthProvider';

const Description = () => {
  const { auth } = useAuth();
  const { t } = useLingui()
  const { intervention, solution_visit, setsolution_visit, solution_extra, setsolution_extra } = useInterventionInput()
  const parameters = useBoundStore((state) => state.parameters)

  let solutionList = parameters
    ?.filter((p) => p.m_iTYPE.toString() === '29')
    .sort((a, b) => a.m_sVALUE.toLowerCase().localeCompare(b.m_sVALUE.toLowerCase()));
  const solutionOptions = solutionList ? solutionList.map((p) => ({ value: p.m_iPARAMID.toString(), label: p.m_sVALUE })) : []

  return (
    <div className='flex flex-col gap-4'>
      <h3 className={`${styles.h3}`}><Trans>Opdracht</Trans></h3>

      <div>
        <Label><Trans>Reden bezoek</Trans></Label>
        <AutosizeTextarea value={intervention?.m_sOMSCHRIJVING || ''} disabled className='text-sm whitespace-pre-line' />
      </div>

      <div>
        <Label><Trans>Extra info (intern)</Trans></Label>
        <AutosizeTextarea value={intervention?.m_sINTCOMM || ''} disabled className='text-sm whitespace-pre-line' />
      </div>

      <h3 className={`${styles.h3}`}><Trans>Externe beschrijving</Trans></h3>

      <div>
        <Label>
          <Trans>Oplossing</Trans>
          {getCustomSettings(auth.data?.databases[0].dbid).intervention?.description?.require_solution &&
            <span className='ml-1 text-red-600'>*</span>
          }
        </Label>
        <Combobox selectedValue={solution_visit || undefined} onValueChange={(v) => { setsolution_visit(v.value.toString()) }} options={solutionOptions} placeholder={t`Selecteer een oplossing...`} />
      </div>

      <div>
        <Label>
          <Trans>Extra uitleg</Trans>
          {getCustomSettings(auth.data?.databases[0].dbid).intervention?.description?.require_solution_extra &&
            <span className='ml-1 text-red-600'>*</span>
          }
        </Label>
        <AutosizeTextarea value={solution_extra || ''} onChange={(e) => { setsolution_extra(e.target.value) }} />
      </div>
    </div>
  )
}

export default Description